import React from "react";
import ReactSelect from "react-select";
import { ISelectProps } from "@components/form/Select/interface";
import { stylesSelect } from "@components/form/Select/style";

const Select = ({
  name,
  placeholder,
  options,
  styles = stylesSelect,
  ...props
}: ISelectProps) => {
  return (
    <ReactSelect
      {...props}
      placeholder={placeholder}
      name={name}
      options={options}
      styles={styles}
    />
  );
};

export default Select;
